import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles'

import style from './Loader.scss';

const Loader = ({ text=null, ...props }) => (
  <div className={style.root} {...props}>
    <div className={style.loadingicon}>
      <svg data-name="Capa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56">
        <g>
          <path
            className={style.loadingicon1}
            d="M51.2,4.61c-4.28-4.28-7-2.77-9.14-.65l9.79,9.79C54,11.62,55.65,9.05,51.2,4.61Z"
          />
          <rect
            className={style.loadingicon2}
            x="43.84"
            y="3.97"
            width="2"
            height="14"
            transform="translate(5.37 34.92) rotate(-45)"
          />
          <rect
            className={style.loadingicon3}
            x="41.01"
            y="6.8"
            width="2"
            height="14"
            transform="translate(2.55 33.75) rotate(-45)"
          />
          <path
            className={style.loadingicon1}
            d="M7.26,38.66l3.18-.35L25.75,23a1,1,0,1,1,1.41,1.41L11.85,39.72l-.53,4.77L16.1,44,38.48,21.58A1,1,0,0,1,39.89,23L17.51,45.37l-.35,3.18L44.84,20.87,34.94,11Z"
          />
          <path
            className={style.loadingicon4}
            d="M10.3,46.62h-.22l-.11,0-.21-.07-.14-.08a1,1,0,0,1-.16-.13l-.1-.13A1,1,0,0,1,9.28,46a1,1,0,0,1,0-.16s0-.06,0-.09a1,1,0,0,1,0-.11,1,1,0,0,1,0-.11l.57-5.12-4.42.49L3.18,50l.36.89L5,52.27l.57.44,9.4-2.24L15.42,46Z"
          />
          <path
            className={style.loadingicon5}
            d="M52.62,3.19c-5-5-9.22-3.51-12.73,0L3.83,39.26l0,.06-.06.08a1,1,0,0,0-.12.24l0,.08v0L0,54.58a1,1,0,0,0,0,.2s0,0,0,0a1,1,0,0,0,.07.33l0,.07a1,1,0,0,0,.2.3,1,1,0,0,0,.33.22,1,1,0,0,0,.38.08l.23,0,14.85-3.53.08,0,.1,0a1,1,0,0,0,.2-.12l.07-.05,0,0L52.62,15.92C56.13,12.41,57.94,8.52,52.62,3.19ZM39.18,6.73,40.6,5.32l9.9,9.9-1.41,1.41ZM42.07,4c2.12-2.12,4.86-3.63,9.14.65,4.44,4.44,2.77,7,.65,9.14ZM17.16,48.56l.35-3.18L39.89,23a1,1,0,0,0-1.41-1.41L16.1,44l-4.77.53.53-4.77L27.16,24.41A1,1,0,1,0,25.75,23L10.44,38.3l-3.18.35L34.94,11l9.9,9.9ZM5.53,52.71,5,52.27,3.55,50.85,3.18,50l2.16-9.08,4.42-.49L9.2,45.51a1,1,0,0,0,0,.11,1,1,0,0,0,0,.11s0,.06,0,.09a1,1,0,0,0,0,.16,1,1,0,0,0,.09.18l.1.13a1,1,0,0,0,.16.13l.14.08.21.07.11,0h.22L15.42,46l-.49,4.42ZM36.35,9.56l1.41-1.41,9.9,9.9-1.41,1.41Z"
          />
        </g>
      </svg>
      {text && <div className={style.txt}>{text}</div>}
    </div>
  </div>
);

Loader.propTypes = {
  text: PropTypes.string,
};

export default withStyles(style)(Loader);
